.root {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 16px;
  border-radius: var(--tuna-shape-borderRadius);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: var(--tuna-typography-body2-lineHeight);
}

.filledError {
  background-color: var(--tuna-palette-error-main);
  color: var(--tuna-palette-error-contrastText);
}

.filledWarning {
  background-color: var(--tuna-palette-warning-main);
  color: var(--tuna-palette-warning-contrastText);
}

.filledInfo {
  background-color: var(--tuna-palette-info-main);
  color: var(--tuna-palette-info-contrastText);
}

.filledSuccess {
  background-color: var(--tuna-palette-success-main);
  color: var(--tuna-palette-success-contrastText);
}

.standardError {
  background-color: color-mix(in srgb, var(--tuna-palette-error-light) 15%, transparent);
  color: var(--tuna-palette-error-dark);
}

.standardWarning {
  background-color: color-mix(in srgb, var(--tuna-palette-warning-light) 15%, transparent);
  color: var(--tuna-palette-warning-dark);
}

.standardInfo {
  background-color: color-mix(in srgb, var(--tuna-palette-info-light) 15%, transparent);
  color: var(--tuna-palette-info-dark);
}

.standardSuccess {
  background-color: color-mix(in srgb, var(--tuna-palette-success-light) 15%, transparent);
  color: var(--tuna-palette-success-dark);
}

.outlined {
  background-color: transparent;
}

.outlinedError {
  border: 1px solid var(--tuna-palette-error-light);
  color: var(--tuna-palette-error-dark);
}

.outlinedWarning {
  border: 1px solid var(--tuna-palette-warning-light);
  color: var(--tuna-palette-warning-dark);
}

.outlinedInfo {
  border: 1px solid var(--tuna-palette-info-light);
  color: var(--tuna-palette-info-dark);
}

.outlinedSuccess {
  border: 1px solid var(--tuna-palette-success-light);
  color: var(--tuna-palette-success-dark);
}

.close {
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  padding: 4px;
  border-radius: var(--tuna-shape-borderRadius);
}

.close:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.title {
  font-weight: 500;
  margin-top: -2px;
}

.icon {
  display: flex;
}
